import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import * as session from './sessionReducer';
import * as form from './formReducer';
import * as serviceMessageSets from './serviceMessageSetsReducer';
import * as deviceEvents from './deviceEventsReducer';
import * as deviceTypes from './deviceTypesReducer';
import * as deviceConfigs from './deviceConfigsReducer';
import * as buildingOrgs from './buildingOrgsReducer';
import * as buildings from './buildingsReducer';
import * as contracts from './contractsReducer';
import * as voiceSets from './voiceSetsReducer';
import * as protocols from './protocolsReducer';
import * as schedules from './schedulesReducer';
import * as checkIns from './checkInsReducer';
import * as themeHistory from './themeHistoryReducer';
import * as features from './featuresReducer';
import * as layouts from './layoutsReducer';
import * as editor from './editorReducer';
import * as users from './usersReducer';
import * as themes from './themesReducer';
import * as shell from './shellReducer';
import * as admin from './adminReducer';
import * as roles from './rolesReducer';
import * as orgs from './orgsReducer';
import * as ecs from './ecsReducer';
import * as api from './apiReducer';
import * as ws from './websocketReducer';

export const initialState = Object.freeze({
    serviceMessageSets: serviceMessageSets.initialState,
    deviceEvents: deviceEvents.initialState,
    deviceTypes: deviceTypes.initialState,
    deviceConfigs: deviceConfigs.initialState,
    buildingOrgs: buildingOrgs.initialState,
    buildings: buildings.initialState,
    contracts: contracts.initialState,
    voiceSets: voiceSets.initialState,
    protocols: protocols.initialState,
    schedules: schedules.initialState,
    checkIns: checkIns.initialState,
    themeHistory: themeHistory.initialState,
    features: features.initialState,
    layouts: layouts.initialState,
    session: session.initialState,
    router: { location: { pathname: '/' } },
    editor: editor.initialState,
    form: form.initialState,
    users: users.initialState,
    themes: themes.initialState,
    shell: shell.initialState,
    admin: admin.initialState,
    roles: roles.initialState,
    orgs: orgs.initialState,
    ecs: ecs.initialState,
    api: api.initialState,
    ws: ws.initialState,
});

export const makeAppReducer = (history?: History) => combineReducers({
    serviceMessageSets: serviceMessageSets.serviceMessageSetsReducer,
    deviceEvents: deviceEvents.deviceEventsReducer,
    deviceTypes: deviceTypes.deviceTypesReducer,
    deviceConfigs: deviceConfigs.deviceConfigsReducer,
    buildingOrgs: buildingOrgs.buildingOrgsReducer,
    buildings: buildings.buildingsReducer,
    contracts: contracts.contractsReducer,
    protocols: protocols.protocolsReducer,
    voiceSets: voiceSets.voiceSetsReducer,
    schedules: schedules.schedulesReducer,
    checkIns: checkIns.checkInsReducer,
    themeHistory: themeHistory.themeHistoryReducer,
    features: features.featuresReducer,
    layouts: layouts.layoutsReducer,
    session: session.sessionReducer,
    router: connectRouter(history || { location: { pathname: '' } } as any),
    editor: editor.editorReducer,
    form: form.formReducer,
    users: users.usersReducer,
    themes: themes.themesReducer,
    shell: shell.shellReducer,
    admin: admin.adminReducer,
    roles: roles.rolesReducer,
    orgs: orgs.orgsReducer,
    ecs: ecs.ecsReducer,
    api: api.apiReducer,
    ws: ws.websocketsReducer,
});
